import { TmdxChip } from '@ds';
import { PropsWithChildren } from 'react';

type ResourceSectionProps = {
  title: string;
  count?: number;
} & PropsWithChildren;

export const ResourceSection = ({ title, children, count }: ResourceSectionProps) => {
  return (
    <div className="mb-8 flex flex-col gap-4">
      <div className="flex gap-2 items-center">
        <h2 className="text-hs text-base-25">{title}</h2>
        {!!count && (
          <TmdxChip
            size="xs"
            className="bg-white! hover:bg-white! border-white! hover:border-white! text-sm text-base-10"
          >
            {count}
          </TmdxChip>
        )}
      </div>
      <div className="flex gap-3 flex-wrap">{children}</div>
    </div>
  );
};
